<template>
  <div>
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <router-view v-if="isUrl('lockup') == true" />
      <div class="body flex-grow-1 px-3 pt-3" v-else>
        <!-- <CContainer lg > -->
          <router-view />
        <!-- </CContainer> -->
      </div>
    </div>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppSidebar,
    CContainer,
  },
  methods: {
    isUrl(str) {
      if(this.$route.path.indexOf(str) > -1){
        return true
      }else{
        return false
      }
    },
  },
}
</script>
